import React, { FC, ReactNode } from 'react';
import { Page } from '../../../components';

interface AppPageProps {
  children: ReactNode;
  padding?: string;
  widePageContent?: boolean;
}

export const AppPage: FC<AppPageProps> = ({ padding = "calc(var(--top-nav-height, 60px) + 1.5rem) 2.5rem 2.5rem", children, widePageContent = true }) => {
  return (
    <Page padding={padding} widePageContent={widePageContent}>
      {children}
    </Page>
  );
};
